import { connect } from "react-redux";
import { readSingleAppData } from "shared/redux-store/dataReaders";

import OrderUnitEditor from "./OrderUnitEditor";
import { submitOrderUnitEditor } from "./orderUnitEditorActions";

const mapStateToProps = (state, ownProps) => {
  return {
    orderUnit: readSingleAppData(state, "orderUnit"),
    isNew: !!ownProps.isNew,
    isSubmitting: state.app.isSubmitting,
    submitErrorCode: state.app.submitErrorCode,
    submitErrorMessages: state.app.submitErrorMessages,
    submitErrorFields: state.app.submitErrorFields,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    submitFn: (orderUnitData, orderUnitId) => {
      dispatch(
        submitOrderUnitEditor({
          pathParams: [orderUnitId],
          requestData: orderUnitData,
        }),
      );
    },
  };
};

const OrderUnitEditorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrderUnitEditor);

export default OrderUnitEditorContainer;
